import { createFileRoute } from '@tanstack/react-router';
import { DeveloperGuide } from '@/features/content/Guide';

export const Route = createFileRoute('/_app/developer-guide')({ component: DeveloperGuide });
